import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../css/AddCategory.css"; // new scoped styling

const AddCategoryForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();

  const saveCategory = (e) => {
    e.preventDefault();

    const data = { title, description };

    fetch("https://goldenhides.in/api/category/add", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((result) =>
        result
          .json()
          .then((res) => {
            if (res.success) {
              toast.success(res.responseMessage, {
                position: "top-center",
                autoClose: 1000,
              });
              setTimeout(() => navigate("/home"), 1200);
            } else {
              toast.error(res.responseMessage || "Error", {
                position: "top-center",
                autoClose: 1200,
              });
            }
          })
          .catch(() => {
            toast.error("Invalid server response", {
              position: "top-center",
              autoClose: 1200,
            });
          })
      )
      .catch((error) => {
        console.error(error);
        toast.error("It seems server is down", {
          position: "top-center",
          autoClose: 1200,
        });
      });
  };

  return (
    <div className="addcategory-page auth-background">
      <div className="d-flex align-items-center justify-content-center mt-4">
        <div className="card addcategory-card border-color custom-bg">
          <div className="card-header addcategory-card-header text-center">
            <h5 className="card-title mb-0 text-white">Add Category</h5>
          </div>

          <div className="card-body text-color">
            <form onSubmit={saveCategory}>
              <div className="mb-3">
                <label htmlFor="title" className="form-label">
                  <strong>Category Title</strong>
                </label>
                <input
                  id="title"
                  type="text"
                  className="form-control"
                  placeholder="enter title.."
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="description" className="form-label">
                  <strong>Category Description</strong>
                </label>
                <textarea
                  id="description"
                  className="form-control"
                  rows="4"
                  placeholder="enter description.."
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
              </div>

              <div className="d-flex justify-content-start">
                <button type="submit" className="btn bg-color custom-bg-text">
                  Add Category
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default AddCategoryForm;
